import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Timer from '../Timer';
import {fetchMainWaterTank, fetchReserveWaterTank} from '../../API/waterTankApi';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexGrow: 1,
    marginTop: 8,
    marginLeft: 10,
    marginRight: 10
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }
}));

function Main(props) {
  const classes = useStyles();
  const [mainTank, setMainTank] = useState({
    siteName: "Main Tank",
    dateTime: "2020-08-13T00:15:15-07:00",
    waterTemperature: 0,
    waterTemperatureDate: new Date().toString(),
    airTemperature: 0,
    airTemperatureDate: new Date().toString(),
    waterLevelPercent: 0,
    waterLevelDate: new Date().toString(),
    mainTankHeight: 0,
    mainTankDiameter: 0,
    mainTankCapacity: 0,
    currentCapacity: 0
  });
  const [reserveTank, setReserveTank] = useState({
    siteName: "Reserve Tank",
    dateTime: "2020-08-13T00:15:30-07:00",
    waterTemperature: 0,
    waterTemperatureDate: new Date().toString(),
    airTemperature: 0,
    airTemperatureDate: new Date().toString(),
    waterLevelPercent: "0",
    waterLevelDate: new Date().toString(),
    reserveTankHeight: 0,
    reserveTankLength: 0,
    reserveTankWidth: 0,
    reserveTankCapacity: 0,
    currentCapacity: 0,
    solarDate: new Date().toString(),
    solarState: "Discharging",
    solarVoltage: "0",
    solarEnergyProduction: "0",
    solarEnergyConsumption: "0"
  });
  const [lastUpdate, setLastUpdate] = useState({
    waterTempDate: null,
    airTempDate: null,
    waterTempDate1: null,
    airTempDate1: null
  });

  useEffect(() => {
    loadMainTankData();
    loadReserveTankData();
    const interval = setInterval(() => {
      loadMainTankData();
      loadReserveTankData();
    }, 120000);
    return () => clearInterval(interval);
  }, []);

  const loadMainTankData = () => {
    fetchMainWaterTank()
        .then(response => {
          if (response.waterTemperatureDate !== setMainTank.waterTemperatureDate) {
            setLastUpdate({
              ...lastUpdate,
              waterTempDate: response.waterTemperatureDate
            });
          }
          if (response.airTemperatureDate !== setMainTank.airTemperatureDate) {
            setLastUpdate({
              ...lastUpdate,
              airTempDate: response.airTemperatureDate
            });
          }
          setMainTank(response);
        })
        .catch(err => {
          console.log('----- error during fetching ---', err);
        });
  };

  const loadReserveTankData = () => {
    fetchReserveWaterTank()
        .then(response => {

          if (response.waterTemperatureDate !== setMainTank.waterTemperatureDate) {
            setLastUpdate({
              ...lastUpdate,
              waterTempDate1: response.waterTemperatureDate
            });
          }
          if (response.airTemperatureDate !== setMainTank.airTemperatureDate) {
            setLastUpdate({
              ...lastUpdate,
              airTempDate1: response.airTemperatureDate
            });
          }
          setReserveTank(response);
        })
        .catch(err => {
          console.log('----- error during fetching ---', err);
        });
  };

  return (
      <>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper className={classes.paper}><h2>RCMWC system status</h2></Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Paper className={classes.paper}>
                <center>
		  <h3>Main Tank</h3>
                  <img
                      src='https://rc.sarrix.net/maintank.jpg'
                      width={320}/>
                </center>
                <p>Air space temp: {mainTank.airTemperature} &#8457; <Timer lastUpdatedTime={mainTank.airTemperatureDate}/></p>
                <p>Water temp: {mainTank.waterTemperature} &#8457; <Timer lastUpdatedTime={mainTank.waterTemperatureDate}/></p>
                <p>{mainTank.waterLevelPercent}% Full ({mainTank.currentCapacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} gals) <Timer lastUpdatedTime={mainTank.waterLevelDate}/></p>
                <p>Tank capacity (max {mainTank.mainTankCapacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} gals) <span style={{float: "right", width: "100px"}}> &nbsp;</span></p>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <Paper className={classes.paper}>
                <center>
		  <h3>Reserve Tank</h3>
                  <img
                      src='https://www.watervision.co.nz/images/Tank-level.gif'
                      width={150} height={150}/>
                </center>
                <p>Air space temp: {reserveTank.airTemperature} &#8457; <Timer lastUpdatedTime={reserveTank.airTemperatureDate}/></p>
                <p>Water temp: {reserveTank.waterTemperature} &#8457; <Timer lastUpdatedTime={reserveTank.waterTemperatureDate}/></p>
                <p>{reserveTank.waterLevelPercent}% Full ({reserveTank.currentCapacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} gals) <Timer lastUpdatedTime={reserveTank.waterLevelDate}/></p>
                <p>Tank capacity (max {reserveTank.reserveTankCapacity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} gals) <span style={{float: "right", width: "100px"}}> &nbsp;</span></p>

              </Paper>
            </Grid>
          </Grid>
        </div>
      </>
  );
}

export default Main;
